import { nodeComponentRegistry } from '../../../r3f/NodeComponentRegistry';
import { FogVolume } from './Component';
import { fogVolumeHasGizmo } from '../../../godot/rendering/environment/fogVolume';
nodeComponentRegistry.register({
    typeName: 'FogVolume',
    Component: FogVolume,
    editorIcon: {
        icon: 'GizmoFogVolume',
        isDrawn: (node) => fogVolumeHasGizmo(node.properties.shape),
    },
});
//# sourceMappingURL=index.r3f.js.map